import createIcon from '../../createIcon';

/**
 * @component @name EventNote
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTFIN1YxM0gxN1YxMVpNMTkgNEgxOFYySDE2VjRIOFYySDZWNEg1QzMuODkgNCAzLjAxIDQuOSAzLjAxIDZMMyAyMEMzIDIxLjEgMy44OSAyMiA1IDIySDE5QzIwLjEgMjIgMjEgMjEuMSAyMSAyMFY2QzIxIDQuOSAyMC4xIDQgMTkgNFpNMTkgMjBINVY5SDE5VjIwWk0xNCAxNUg3VjE3SDE0VjE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const EventNote = createIcon('EventNote', [
  [
    'path',
    {
      d: 'M17 11H7V13H17V11ZM19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V9H19V20ZM14 15H7V17H14V15Z',
      key: '1r0gub',
    },
  ],
]);

export default EventNote;
